<div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
    </div>
  </div>
  <div class="field-value" *ngIf="fieldSubmission.serialized_value; else emptyField">
    <span>{{fieldSubmission.serialized_value.name}}</span>
  </div>
  <ng-template #emptyField>
    <div class="empty_field">
      <span>This field has no content</span>
    </div>
  </ng-template>
</div>